import { useMemo, useState, useEffect } from 'react'
import './UnitsDrawer.scss'

// Shared unit-selection drawer used by Summary and Metrics. Lists every unit with a
// search box + All/None bulk actions; onApply({ units: [serial, ...] }). An empty
// selection is the caller's choice to interpret (Metrics = none; Summary = all units).
export const UnitsDrawer = ({ open, onClose, units, value, onApply, title = 'Units' }) => {
  const [search, setSearch] = useState('')
  const [selected, setSelected] = useState(value.units || [])

  // Re-sync when reopened so the drawer reflects the current selection.
  useEffect(() => { if (open) setSelected(value.units || []) }, [open]) // eslint-disable-line react-hooks/exhaustive-deps

  const filtered = useMemo(
    () => units.filter(u => `${u.name} ${u.serial}`.toLowerCase().includes(search.toLowerCase())), [units, search])

  const toggle = (s) => setSelected(cur => cur.includes(s) ? cur.filter(x => x !== s) : [...cur, s])

  if (!open) return null
  return (
    <div className="rz-ud-scrim" onClick={onClose}>
      <aside className="rz-ud" onClick={e => e.stopPropagation()}>
        <h3>{title}</h3>
        <div className="rz-ud-units">
          <input className="rz-ud-search" placeholder="filter units…" value={search} onChange={e => setSearch(e.target.value)} />
          <div className="rz-ud-bulk">
            <button onClick={() => setSelected(units.map(u => u.serial))}>All</button>
            <button onClick={() => setSelected([])}>None</button>
          </div>
          <ul>
            {filtered.map(u => (
              <li key={u.serial}><label><input type="checkbox" checked={selected.includes(u.serial)} onChange={() => toggle(u.serial)} /> {u.name || u.serial}</label></li>
            ))}
          </ul>
        </div>
        <div className="rz-ud-actions">
          <button className="rz-ud-apply" onClick={() => { onApply({ units: selected }); onClose() }}>Apply</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </aside>
    </div>
  )
}

export default UnitsDrawer
